export const marketingEs = {
  // FreeMagnetPage
  'marketing.free.seo.title': 'Iniciación gratuita',
  'marketing.free.seo.description':
    'Consigue la Iniciación gratuita de Grymwyrd — las reglas y una aventura de una sesión que puedes dirigir esta noche. Entra en el Crepúsculo.',
  'marketing.free.eyebrow': 'Tu paso libre',
  'marketing.free.heading': 'Entra en el Crepúsculo — gratis',
  'marketing.free.subheadLead': 'La',
  'marketing.free.quickstartName': 'Iniciación Grymwyrd',
  'marketing.free.subheadTail':
    '— reglas básicas más una aventura de una sesión que puedes dirigir esta noche. Dinos dónde enviarlo.',
  'marketing.free.benefit.rules.title': 'Las reglas',
  'marketing.free.benefit.rules.body': 'Todo lo que necesitas para jugar, destilado en una iniciación.',
  'marketing.free.benefit.oneShot.title': 'Una aventura de una sesión',
  'marketing.free.benefit.oneShot.body': 'Una aventura de horror lista para dirigir tu primera noche.',
  'marketing.free.benefit.livingWorld.title': 'Mundo vivo',
  'marketing.free.benefit.livingWorld.body': 'Conexiones con una enciclopedia, mapas y actualizaciones semanales.',
  'marketing.free.playInstead.heading': '¿Prefieres jugar?',
  'marketing.free.playInstead.body':
    'Forja tu primer personaje y juega una prueba en solitario de 10 minutos — sin compras, sin compromisos.',
  'marketing.free.playInstead.cta': 'Forja un personaje',

  // LeadCaptureForm
  'marketing.leadForm.error.generic': 'Algo ha fallado. Inténtalo en un momento.',
  'marketing.leadForm.ready': 'Tu Iniciación gratuita está lista.',
  'marketing.leadForm.downloadCta': 'Descarga tu Iniciación',
  'marketing.leadForm.alsoEmailed': 'También hemos enviado el enlace a tu bandeja de entrada.',
  'marketing.leadForm.checkInbox': 'Comprueba tu bandeja de entrada — tu Iniciación gratuita está en camino.',
  'marketing.leadForm.emailPlaceholder': 'tu@ejemplo.com',
  'marketing.leadForm.emailAriaLabel': 'Dirección de correo electrónico',
  'marketing.leadForm.defaultCta': 'Envíame la Iniciación',
  'marketing.leadForm.privacyNote':
    'Sin spam — solo la Iniciación y algún apunte de lore ocasional. Darte de baja en cualquier momento.',
}
